import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'

IrcMenu.propTypes = {
  menu: PropTypes.object,
  translate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  root: PropTypes.string.isRequired,
  accessMenus: PropTypes.func,
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  cdMenuChild: PropTypes.number,
  hasTitle: PropTypes.bool,
  headerTitle: PropTypes.string,
  isSupply: PropTypes.bool,
  hidden: PropTypes.bool
}

export default function IrcMenu({
  translate,
  hidden = false,
  title,
  text,
  cdMenuChild,
  root,
  accessMenus,
  user,
  hasTitle = false,
  headerTitle,
  isSupply = false
}) {
  const linkClick = (cdMenuChild, root) => {
    switch (root) {
      case 'total-accuracy':
        cdMenuChild = 986
        break
      case 'sections-accuracy':
        cdMenuChild = 985
        break
      case 'rotative-inventory':
        cdMenuChild = 983
        break
      case 'higher-adjustments':
        cdMenuChild = 981
        break
      case 'rupture-irc':
        cdMenuChild = 984
        break
      case 'kardex':
        cdMenuChild = 982
        break
      case 'zerocost-dpac-items':
        cdMenuChild = 987
        break
      case 'supply-accuracy-effectiveness':
        cdMenuChild = 988
        break
      case 'supply-count-history':
        cdMenuChild = 989
        break
      default:
        break
    }
    accessMenus(user, cdMenuChild)
  }

  return (
    hasTitle ? 
    <div className='irc-menu-content-header-title'>
      <p>{headerTitle}</p>
      <Link
      className={`report-button-container ${isSupply ? 'container-supply' : ''} `}
      to={`/${root}`}
      onClick={() => linkClick(cdMenuChild, root)}
      >
        <span className='button-title'>{translate(title)}</span>
        <p style={{marginTop: root === "sections-accuracy" && "0.2rem", lineHeight: "16.8px"}} className='button-description'>{translate(text)}</p>
      </Link>
    </div>
    :
    <Link

      
      className={`report-button-container ${isSupply ? 'container-supply' : ''} ${hidden ? 'invisible' : ''}`}
      to={`/${root}`}
      onClick={() => linkClick(cdMenuChild, root)}
    >
      <span className='button-title'>{translate(title)}</span>
      <p style={{marginTop: root === "sections-accuracy" && "0.2rem", lineHeight: "16.8px"}} className='button-description'>{translate(text)}</p>
    </Link>
  )
}
